import styled from 'styled-components';

const PaymentBreakDownRow = styled.div`
  display: flex;
  width: 100%;
  margin: 3px 0;
  justify-content: space-between;
`;

const PaymentBreakDownWrapper = styled.div`
    display: flex;
    flex-direction: column;
    font-family: ${(props) => props.theme.font.family};
    align-items: center;
    font-weight: ${(props) => props.theme.font.weight.v100};
    margin: 0
    color: white;
    
     ${PaymentBreakDownRow}:last-child {
        font-weight: bold;
    }
`;

const Title = styled.p`
    ${(props) => props.theme.font.subhead.v400}};        
    align-self: flex-start;
    font-weight: bold;
    margin-bottom: 5px;
`;

const Label = styled.p`
  padding: 0;
  margin: 0;
`;

const BoldLabel = styled(Label)`
  font-weight: ${(props) => props.theme.font.weight.v300};
`;

const HR = styled.hr`
  border: 1px solid ${(props) => props.theme.color.neutral.v300};
  width: 100%;
  margin: 15px 0;
  border-bottom-color: transparent;
`;

const Note = styled.p`
  margin-bottom: 5px;
`;

export {
  PaymentBreakDownWrapper,
  PaymentBreakDownRow,
  Label,
  BoldLabel,
  Title,
  HR,
  Note,
};
